import {
  fetchAllAdhocCharge,
  createReasonForAdhocCharge,
  updateReasonForAdhocCharge,
} from '@api/appFlowConfig';

const getKeyMappingReasonSingle = (masterData) => {
  return (
    masterData.ops_dashboard_config?.config?.adhoc_charges_config
      ?.csv_field_list || []
  );
};

const reasonFormItemLayout = {
  labelCol: { span: 12 },
  wrapperCol: { span: 12 },
};

const viewControl = {
  pageTitle: 'Setup',
  buckets: ['addAdhocCharges'],
  globalActions: [],
  addOptions: [
    {
      key: 'add_single',
      title: 'Single',
      action: 'add',
      type: 'single',
    },
  ],
  id: ['charge_id', 'object_type', 'entity_type', 'label'],
  getEditDisabledFields: (masterData) => {
    if (masterData?.worker_payout_config?.enable_custom_adhoc_charges) {
      return ['category', 'document_target', 'charge_type'];
    }
    return [];
  },
  fetchData: fetchAllAdhocCharge,
  onSingleAdd: createReasonForAdhocCharge,
  add: {
    sampleUrl: undefined,
    downloadSampleCsvFromApiCall: false,
    downloadSampleCsv: null,
    title: 'Add Charge',
  },
  warningMsg: 'No Charge to upload',
  successMsg: 'Uploaded Successfully',
  updateMsg: 'Updated Successfully',
  useDrawer: true,
  drawerWidth: '60%',
  modalHeading: 'Upload Charge',
  singleUploadMapping: getKeyMappingReasonSingle,
  onSingleUpdate: updateReasonForAdhocCharge,
  formItemLayout: reasonFormItemLayout,
};

const buckets = {
  addAdhocCharges: {
    name: 'Charges',
    filters: [],
    actions: [],
  },
};

const bucketColor = {};

export default { viewControl, buckets, bucketColor };
